import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const LINK = styled(Link)`
  text-decoration: none;
`

export const VideoContainer = styled.div`
  width: 25vw;

  @media (max-width: 576px){
    width: 96vw;
    margin-left: 6px;
  }

  @media (max-width: 768px){
    width: 45vw;
  }
`

export const VImg = styled.img`
  width: 100%;
`

export const VCard = styled.div`
  display: flex;
  gap: 20px;
  padding: 10px;
`

export const VIcon = styled.img`
  width: 40px;
  height: 40px;
`

export const VText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${props => props.colorP};
`

export const VTitle = styled.p`
  color: ${props => props.color};
  font-size: 14px;
  font-weight: normal;
`

export const VName = styled.p`
  font-size: 13px;
`
